module.exports = {"pathContext":{"name":"UsageReport","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"orderItems","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"OrderItem","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totals","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"UsageReportTotals","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-usage-report.json
// module id = 2080
// module chunks = 54639839271931